import { inlineHeadingHtml } from '../../sanitize/inlineHeadingHtml.js';
import { sanitizeRichtextHtml } from '../../sanitize/sanitizeRichtextHtml.js';
import { escapeHtml } from '../../sections/_shared/settingValue.js';
/**
 * A one-line message as SAFE inline HTML, whatever shape the setting holds (24/09/2026 — the urgency
 * line and the urgency box, whose text became rich so a word can carry its own colour).
 *  - `{format:'html'}` (the inspector's richtext editor, with its coloured spans): sanitized by the shared
 *    policy, then flattened to phrasing content — the editor wraps every line in `<p>`, and a paragraph
 *    inside a flex row or a framed `<p>` would break the line away from its icon or its frame.
 *  - a plain string (every store that set the text before 24/09, and the AI composer's output): escaped,
 *    so `<b>` typed by a seller shows as `<b>`, never runs as markup.
 * A blank result (an emptied editor, an unset field) is `''` — the caller falls back to the dictionary.
 */
export function inlineMessageHtml(value) {
    if (value && typeof value === 'object' && value.format === 'html') {
        const raw = value.html;
        const html = inlineHeadingHtml(sanitizeRichtextHtml(typeof raw === 'string' ? raw : ''));
        return html.replace(/<[^>]*>/g, '').trim().length > 0 ? html : '';
    }
    return typeof value === 'string' && value.trim().length > 0 ? escapeHtml(value) : '';
}
//# sourceMappingURL=inlineMessage.js.map